import { render, staticRenderFns } from "./OptInNotification.vue?vue&type=template&id=1a7212fe&scoped=true&"
import script from "./OptInNotification.vue?vue&type=script&lang=js&"
export * from "./OptInNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7212fe",
  null
  
)

export default component.exports